module.exports = __webpack_public_path__ + "img/tuihui-h.b7dea680.svg";